<template>
    <div class="full-width full-height dynamic-form q-pa-md">
      <div class="row q-pa-md q-py-sm q-col-gutter-x-lg q-col-gutter-y-xs" style="height: calc(38vh - 12px);">
        <jt-dynamic-form
            v-if="formModel"
            ref="jtDynamicForm"
            :inputs="formModel.inputs"
            :interface="formModel.nmInterface"
            :relacionamentos="formModel.relacionamentos"
            :model="contractService"
            no-scroll
            form-class="jtDFModalReasonJustificationWaste"
        />
      </div>
      <div class="row full-width q-col-gutter-lg justify-center q-py-lg">
          <div v-for="(button, i) in formModel.buttons" :key="i" class="col-lg-2 col-md-3">
              <q-btn class="full-width" color="info" @click="actionButton(button)">
              <q-icon
                  v-if="button.icon"
                  :name="button.icon"
                  size="18px"
                  class="position-icon-filter"
              />
              {{ button.label }}
              </q-btn>
          </div>
      </div>
    </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtTextInput, JtSelect } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
const { modal } = JtCrud
import 'leaflet/dist/leaflet.css'
import ContractServiceRegister from './ContractServiceRegister.vue'

@Component({
  components: {
    JtTextInput,
    JtSelect
  },
  mixins: [modal],
  name: 'ContractServiceFormPage',
  props: {
    forms: {},
    collectionPoint: {},
    title: String
  }
})
class ContractServiceFormPage extends Vue {
    formModel = {};
    form = [];
    contractService = {};

    created () {
      this.generateForm()
    }

    async generateForm () {
      this.form = await repository.resolve('contractService.registrarNovo', this.params)
      this.formModel = this.form[0]
    }

    get elInputs () {
      return this.formModel.inputs
    }

    get inputs () {
      return this.form[0].inputs
    }

    async actionButton (button, params, page) {
      if (!this.$refs.jtDynamicForm.isValidForm()) {
        return
      }
      this.getTextFromSelect(this.contractService.serviceType, 'serviceType')
      this.getTextFromSelect(this.contractService.contractType, 'contractType')
      this.getTextFromSelect(this.contractService.billingMeasurementType, 'billingMeasurementType')
      this.$emit('confirm', this.contractService)
    }

    getTextFromSelect (itemValue, inputName) {
      if (this.formModel.relacionamentos[inputName] != null) {
        const textEvent = this.formModel.relacionamentos[inputName].find(type => type.value == itemValue).label
        this.contractService[inputName + 'Text'] = textEvent
      }
    }

    prepareInputs (inputs) {
      return inputs
    }
}
export default ContractServiceFormPage
</script>
<style lang="stylus" scoped>
</style>
